import {
  logEvent as firebaseLogEvent,
  setUserId, setUserProperties
} from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { logEvent, getAnalytics } from "firebase/analytics";
//import { analytics } from "../firebase";

//const analytics = getAnalytics();
const auth = getAuth();

// Set User ID when user is authenticated
auth.onAuthStateChanged((user) => {
  if (user) {
    // setUserId(analytics, user.uid);
    // setUserProperties(analytics, {
    //   email: user.email,
    //   timestamp: new Date().toISOString(),
    // });
  }
});

export const logAppEvent = (
  eventName: string,
  params: { [key: string]: any }
) => {
  // logEvent(analytics, eventName, {
  //   ...params
  // });
};
